import {Directive, ElementRef, EventEmitter, Inject, OnInit, Output, Input} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
declare var confPopup: any;

@Directive({
    selector: '[Confirmation]'
  })
  
  export class ConfirmationDirective implements OnInit {
  
    @Output() confirmationClick = new EventEmitter<boolean>();
    @Output() else = new EventEmitter<boolean>();
    @Input() confirmationText: string;
  
    constructor(@Inject(ElementRef) private element: ElementRef, private translate: TranslateService) 
    { 
      
    }
  
    async ngOnInit() 
    {
      var ConfirmButton = document.querySelector("#modal-btn-yes");
      var CancelButton = document.querySelector("#modal-btn-no");
      var CloseButton = document.querySelector("#modal-btn-close");
      document.querySelector("#myModalHeader").textContent = await this.translate.get('SHARED.Confirmation').toPromise();
      document.querySelector("#myModalBody").textContent = this.confirmationText != undefined ? this.confirmationText : await this.translate.get('SHARED.AreYouSure').toPromise();
      document.querySelector("#modal-btn-yes").textContent = await this.translate.get('SHARED.Yes').toPromise();
      document.querySelector("#modal-btn-no").textContent = await this.translate.get('SHARED.No').toPromise();
      const directive = this;

      this.element.nativeElement.onclick = function() 
      {
        var modalConfirm = function(callback)
        {
          confPopup.modal('show');
          ConfirmButton.addEventListener("click", addConfirmationEventListener);
          CancelButton.addEventListener("click", addCancelEventListener);
          CloseButton.addEventListener("click", addCancelEventListener);

          function addConfirmationEventListener(){
            callback(true);
            confPopup.modal('hide');
            ConfirmButton.removeEventListener("click", addConfirmationEventListener);
            CancelButton.removeEventListener("click", addCancelEventListener);
            CloseButton.removeEventListener("click", addCancelEventListener);
          }

          function addCancelEventListener(){
            callback(false);
            confPopup.modal('hide');
            ConfirmButton.removeEventListener("click", addConfirmationEventListener);
            CancelButton.removeEventListener("click", addCancelEventListener);
            CloseButton.removeEventListener("click", addCancelEventListener);
          }
        };
        
        modalConfirm(function(confirm){
          if(confirm)
          {
            directive.confirmationClick.emit(true);
          }
        });
      };
    }
    
  }